import toast from 'react-hot-toast'

import { showApiError, useMutation } from '@fv/client-core'

import { adminFetch } from '@/utils'

export function useClearAccountUserSessions() {
  return useMutation({
    mutationFn: (userId: string) =>
      adminFetch(`/sessions/account-user/${userId}`, {
        method: 'DELETE',
      }),
    onError: e => {
      showApiError('Error clearing sessions', e)
    },
    onSuccess: () => {
      toast.success('All sessions cleared successfully')
    },
  })
}

export function useClearUserSessions() {
  return useMutation({
    mutationFn: (userId: string) =>
      adminFetch(`/sessions/user/${userId}`, {
        method: 'DELETE',
      }),
    onError: e => {
      showApiError('Error clearing sessions', e)
    },
    onSuccess: () => {
      toast.success('All sessions cleared successfully')
    },
  })
}
